// extracted by mini-css-extract-plugin
export default {"layout":"DefaultLayout_layout__BBnoV"};